<script setup>

import DashboardTable from '../components/Table.vue';
import { useRouter } from 'vue-router';
const router = useRouter();

const createUpdateDashboard = (id) => {
    id = parseInt(id, 10);
    if (id !== null && Number.isInteger(id) && id > 0) {
        router.push({ name: 'UpdateDashboard', params: { id } });
    } else {
        router.push({ name: 'CreateDashboard'});
    }
}

</script>

<template>
    <div>
        <h5>All Existing Dashboards</h5>

        <div class="card">
            <b>Please note</b>: only the first Dashboard will be used as Homepage.<br />
            The list is ordered using the following criteria:
            <ol class="list-none p-0 m-0 ">
                <li class="py-2 px-2">
                    <b>default</b>: Dashboards appointed as default will be the first displayed.
                </li>
                <li class="py-2 px-2">
                    <b>order</b>: among the same Default value, the Dashboard will be ordered using the, optional,
                    order field.
                </li>
                <li class="py-2 px-2">
                    <b>id</b>: in case that multiple Dashboard have the same order (and the same default configuration),
                    they will be ordered by id.
                </li>
            </ol>
        </div>

        <div class="card flex justify-content-end">
            <Button label="Add New Dashboard" icon="pi pi-plus" class="mb-2" @click="createUpdateDashboard(null)" />
        </div>

        <!-- Dashboard lists table -->
        <DashboardTable @updateDashboard="createUpdateDashboard" />
    </div>
</template>
